import { useSelector } from 'react-redux';
import Constants from '../../constants';
import { isSmartPhone } from '../../utilities/helper';
import useTheme from '../../utilities/hooks/theme';
import './index.css';

const Chest = ({ item, index, setSelectedChestReward, allLevels }: any) => {
  const userLevel = useSelector((state: any) => state.user?.userLevel);
  const userCurrentXp = useSelector((state: any) => state.user?.xpPoints || 0);
  const { AccountTheme: theme } = useTheme();
  if (index === 0) return null;

  const { id, xp_required = 0, gem } = item || {};

  const currentLevel = index;

  const isCurrentLevelSelected = userLevel >= currentLevel;

  const previousLevelXpRequired = index === 0 ? 0 : allLevels[index - 1].xp_required;
  const currentLevelXpRequired = xp_required - previousLevelXpRequired;
  const currentLevelXpAchieved =
    userCurrentXp > previousLevelXpRequired
      ? userCurrentXp - previousLevelXpRequired > currentLevelXpRequired
        ? currentLevelXpRequired
        : userCurrentXp - previousLevelXpRequired
      : 0;

  let percentage: any = (currentLevelXpAchieved * 100) / currentLevelXpRequired;
  percentage = Math.round(percentage);
  percentage = `${percentage}%`;

  const onClickChest = () => {
    let message = '';
    if (isCurrentLevelSelected) {
      message = 'You have already claimed the reward.';
    } else if (currentLevelXpAchieved !== 0) {
      message = `Earn ${
        currentLevelXpRequired - currentLevelXpAchieved
      } more out of ${currentLevelXpRequired} xp points to unlock rewards for current level`;
    } else {
      message = `This level requires ${currentLevelXpRequired} xp to unlock this`;
    }

    setSelectedChestReward(message);
  };

  const chestWrapperStyle = {
    background: isCurrentLevelSelected
      ? theme.dailyRewardsActiveItemBg
      : theme.dailyRewardsDefaultItemBg,

    border: `solid 1px ${
      isCurrentLevelSelected ? theme.dailRewardsActiveItemBorder : theme.dailyRewardsDefaultItemBg
    }`
  };

  const coinsBackgroundStyle = {
    backgroundColor: theme.dailyRewardsCoinsBg
  };
  const chestProgressStyle = {
    background: theme.dailyRewardsChestProgressBg,
    border: 'none'
  };
  const chestProgressedAreaStyle = {
    background: theme.dailyRewardsChestProgressedAreaBg,
    boxShadow: theme.dailyRewardsChestProgressedAreaBoxShadow
  };
  return (
    <li
      className={`chest__wrapper ${isCurrentLevelSelected ? 'active' : ''}`}
      style={chestWrapperStyle}
      key={id}
      onClick={onClickChest}>
      <img
        className={isSmartPhone ? 'chest__chestImg__mWeb' : 'chest__chestImg'}
        src={isCurrentLevelSelected ? Constants.Images.chestActive : Constants.Images.chestClosed}
        alt="chest"
      />
      {!isCurrentLevelSelected && <img className="chest__lock" src={Constants.Images.lock} />}
      <div className={isSmartPhone ? 'chest__lvl__txt__mWeb' : 'chest__lvl__txt'}>
        LEVEL {index}
      </div>
      <div
        className={isSmartPhone ? 'chest__coins__mWeb' : 'chest__coins'}
        style={coinsBackgroundStyle}>
        <Constants.Svgs.Coins />
        <p>COINS {gem}</p>
      </div>

      <div
        className={`chest__progress ${percentage === '0%' ? 'invisible' : ''}`}
        style={chestProgressStyle}>
        <div
          className="chest__progress-bar"
          role="progressbar"
          style={{
            width: percentage,
            ...chestProgressedAreaStyle
            // border: percentage === '100%' ? 'solid 1px #fff' : 'solid 1px #917ec6;'
          }}></div>
        <div className="chest__progress-text-wrapper">
          <div className="chest__progress-text">{percentage}</div>
        </div>
      </div>
    </li>
  );
};

export default Chest;
